import {
  firestoreLite,
  collection,
  getDocs,
  getDoc,
  query,
  where,
  doc,
  collectionGroup
} from '../../utils/firestoreLite'

import {
  jobCollection,
  jobOpenStatus,
  jobBoxesCollection,
  jobCreated,
  jobTransmitted,
  jobReportCollection,
  boxReadyForQc,
  boxQcStarted,
  // jobStarted
} from '../common/appConstants'

/**
 * @description this method will pull the documents
 * which are in Pending, In Process and Assigned statuses 
 * @param {string} district current logged in district
 * @returns {object} job documents which are still open
 */
export const openJobs = async (district) => {
  const jobQuery = query(collection(firestoreLite, jobCollection), where('districtId', '==', district),
    where('jobStatus', 'in', jobOpenStatus))
  const openJobSnapshot = await getDocs(jobQuery)
  return openJobSnapshot
}

/**
 * @description this method will get the collection group
 * of boxes belongs to job
 * @param {string} fromDate todat start date time
 * @param {string} toDate today end date time
 * @param {string} district cuurent district
 * @param {object} jobIdList list of job ids
 * @returns {object} box list for the job
 */

export const boxDocsForJob = async (district, jobIdList, fromDate = false, toDate = false) => {
  if (fromDate && toDate) {
    const args = []
    let index = 0
    args[index] = collectionGroup(firestoreLite, jobBoxesCollection)
    args[++index] = where('districtId', '==', district)
    args[++index] = where('jobId', 'in', jobIdList)
    args[++index] = where('transmittedTs', '>=', fromDate)
    args[++index] = where('transmittedTs', '<=', toDate)
    const queries = query.apply(null, args)
    const boxActivities = getDocs(queries)
    return boxActivities
  } else {
    const boxActivities = await getDocs(query(collectionGroup(firestoreLite, jobBoxesCollection), 
      where('districtId', '==', district), where('jobId', 'in', jobIdList)))
    return boxActivities
  }
}

export const allBoxDocsForJob = async (district, fromDate = false, toDate = false) => {
  if (fromDate && toDate) {
    const args = []
    let index = 0
    args[index] = collectionGroup(firestoreLite, jobBoxesCollection)
    args[++index] = where('districtId', '==', district)
    args[++index] = where('transmittedTs', '>=', fromDate)
    args[++index] = where('transmittedTs', '<=', toDate)
    const queries = query.apply(null, args)
    const boxActivities = getDocs(queries)
    return boxActivities
  }
}

/**
 * 
 * @param {string} district district id info
 * @param {object} startDate today start date in America/New_York
 * @param {object} endDate today end date in America/New_York
 * @returns {object} job collections
 */
export const todayTransmittedJobs = async (district, startDate, endDate) => {
  const jobIds = await getDocs(query(collection(firestoreLite, jobCollection), 
    where('districtId', '==', district), where('jobStatus', '==', jobTransmitted), 
    where('transmittedTs', '>=', startDate), where('transmittedTs', '<=', endDate)))
  return jobIds
}

/**
 * 
 * @param {string} district district info
 * @param {string} workerId worker id info
 * @returns {object} job details
 */
export const myJob = async (district, workerId) => {
  const myJobInfo = await getDocs(query(collection(firestoreLite, jobCollection), 
    where('districtId', '==', district), where('assignedUserList', 'array-contains', workerId),
    where('jobStatus', 'in', jobOpenStatus)))  
  return myJobInfo
}

export const myJobTransmittedToday = async (district, workerId, startDate, endDate) => {
  const myTransmittedJobInfo = await getDocs(query(collection(firestoreLite, jobCollection), 
    where('districtId', '==', district), where('assignedUserList', 'array-contains', workerId),
    where('jobStatus', '==', jobTransmitted), 
    where('transmittedTs', '>=', startDate), where('transmittedTs', '<=', endDate)))  
  return myTransmittedJobInfo
}

export const getJobsWithQCBoxes = async (district) => {
  const collectionQuery = query(
    collectionGroup(firestoreLite, jobBoxesCollection),
    where('status', 'in', [boxReadyForQc, boxQcStarted]),
    where('districtId', '==', district))

  const jobIdList = []
  // const jobWithQcBoxes = []
  const result = await getDocs(collectionQuery)
  result.docs.forEach((doc) => {
    jobIdList.push(doc.ref.parent.parent.id)
  })
  
  // const jobQuery = query(collection(firestoreLite, jobCollection), where('districtId', '==', district),
  //   where('jobStatus', '==', jobStarted))
  // const openJobSnapshot = await getDocs(jobQuery)
  // openJobSnapshot.forEach((doc) => {
  //   if (jobIdList.includes(doc.id)) {
  //     jobWithQcBoxes.push(doc.id)
  //   }
  // })
  return [...new Set(jobIdList)]
}

export const unAssignedJobs = async (district) => {
  const unAssignedJobInfo = await getDocs(query(collection(firestoreLite, jobCollection),
    where('districtId', '==', district),
    where('jobStatus', '==', jobCreated)))
  return unAssignedJobInfo
}

export const getJobStatisticsForDistrict = async (district) => {
  try {
    const docRef = doc(firestoreLite, jobReportCollection, district)
    const docSnapshot = await getDoc(docRef)

    if (docSnapshot.exists()) {
      const jobStatisticsData = docSnapshot.data()
      return jobStatisticsData
    } else {
      return null
    }
  } catch (error) {
    // eslint-disable-next-line
    console.error('Error fetching job statistics:', error)
    throw new Error(`getJobStatisticsForDistrict errored out: ${error.message}`)
  }
}

export const getMyJobStatisticsForWorker = async (district, workerId) => {
  try {
    const docRef = doc(firestoreLite, jobReportCollection, `${workerId}-${district}`)
    const docSnapshot = await getDoc(docRef)

    if (docSnapshot.exists()) {
      const myJobStatisticsData = docSnapshot.data()
      return myJobStatisticsData.data
    } else {
      return null
    }
  } catch (error) {
    // eslint-disable-next-line
    console.error('Error fetching job statistics:', error)
    throw new Error(`getMyJobStatisticsForWorker errored out: ${error.message}`)
  }
}